import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-foreground px-4 py-2 text-center" data-id="element-210" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-semibold leading-snug text-card sm:text-xs" data-id="element-211" data-mp="1ir7t0e0939s0">
        <span className="sm:hidden" data-id="element-212" data-mp="1iovgwhh6btmv">Pobierasz od razu · Drukujesz w domu</span>
        <span className="hidden sm:inline" data-id="element-213" data-mp="1dsxze7u6ch8i">
          Pobierasz od razu · Drukujesz w domu · Dla ciekawskich dzieci 5–12 lat
        </span>
      </p>
    </div>;
}